// extracted by mini-css-extract-plugin
module.exports = {"divider":"reference-navigation_divider___PicV"};